module.exports = __webpack_public_path__ + "img/GAME_GLACIER1.9bd827df.jpg";